<div class="input-group">
    <app-material-date-range
        class="ms-1"
        id="selectedDateRangeGregorian"
        [(dateRange)]="dateRange"
        (dateRangeChange)="selectDateRange($event)"
        >
    </app-material-date-range>

    <app-material-auto-complete
        class="ms-1"
        [formatter]="vesselListFormatter"
        placeholder="Vessel"
        [ngModel]="_selectedVessel"
        (ngModelChange)="selectVessel($event)"
        name="vessel"
        [items]="vessels">
    </app-material-auto-complete>
</div>